import { defineMessages } from "react-intl";

export const portalMessages = defineMessages({
  platformName: {
    defaultMessage: "Employee portal",
    id: "LVnamb",
    description: "employee portal name in its top bar and window title",
  },
  todayModule: { defaultMessage: "Today", id: "h2OIzx", description: "portal nav: punch clock" },
  recordsModule: {
    defaultMessage: "My records",
    id: "91+M0D",
    description: "portal nav: own time records",
  },
  rosterModule: { defaultMessage: "Shifts", id: "qVconx", description: "portal nav: shift roster" },
  overtimeModule: {
    defaultMessage: "Overtime",
    id: "htiRCh",
    description: "portal nav: overtime requests",
  },
  profileModule: {
    defaultMessage: "My data",
    id: "QqdK71",
    description: "portal nav: own profile",
  },
  teamModule: {
    defaultMessage: "Management",
    id: "KbYOzf",
    description: "portal nav: management dashboard",
  },
  setupModule: {
    defaultMessage: "Settings",
    id: "+IK+4+",
    description: "portal nav: shifts, sites, rules",
  },
  noProfileTitle: {
    defaultMessage: "No employee profile",
    id: "Dobt5I",
    description: "portal: user has no employee profile",
  },
  noProfileBody: {
    defaultMessage: "Your account has no employee profile yet. Ask management to create it.",
    id: "i5qtf/",
    description: "portal: user has no employee profile",
  },
  // policy gate
  policiesTitle: {
    defaultMessage: "Before you start",
    id: "3+rYBD",
    description: "portal: first sign-in documents title",
  },
  policiesIntro: {
    defaultMessage:
      "Please read the documents below. Acknowledging them is recorded with the date and the exact version you read.",
    id: "NZhEgz",
    description: "portal: first sign-in documents intro",
  },
  acknowledge: {
    defaultMessage: "I have read and understood",
    id: "GcKrRM",
    description: "portal: acknowledge mandatory document button",
  },
  consentAccept: {
    defaultMessage: "I agree",
    id: "VcRTun",
    description: "portal: optional consent accept",
  },
  consentRefuse: {
    defaultMessage: "I do not agree",
    id: "mzG5jj",
    description: "portal: optional consent refuse",
  },
  optionalConsent: {
    defaultMessage: "Optional — you may refuse without any consequence.",
    id: "T1dTuB",
    description: "portal: optional consent hint",
  },
  // today
  hello: { defaultMessage: "Hello, {name}", id: "VFpNpR", description: "portal greeting" },
  statusOut: { defaultMessage: "Not working", id: "lNP5Pw", description: "portal punch state" },
  statusIn: { defaultMessage: "Working", id: "jnhnGQ", description: "portal punch state" },
  statusBreak: { defaultMessage: "On a break", id: "mGRPwk", description: "portal punch state" },
  kindIn: { defaultMessage: "Clock in", id: "gblXPA", description: "punch kind" },
  kindBreakStart: { defaultMessage: "Start break", id: "sXxHxY", description: "punch kind" },
  kindBreakEnd: { defaultMessage: "End break", id: "DNJcC2", description: "punch kind" },
  kindOut: { defaultMessage: "Clock out", id: "NcH/N5", description: "punch kind" },
  locating: {
    defaultMessage: "Getting your location…",
    id: "N1F551",
    description: "portal punching",
  },
  punchSaved: {
    defaultMessage: "Recorded at {time}.",
    id: "7bwFHe",
    description: "portal punch success",
  },
  noLocation: {
    defaultMessage:
      "Location unavailable: the punch is recorded but flagged for review. Allow location access for this site.",
    id: "0mOmY4",
    description: "portal punch without location",
  },
  locationNotice: {
    defaultMessage:
      "Your location is read only at the moment you punch, never tracked. The time is always the server's.",
    id: "T+jFkS",
    description: "portal location privacy notice",
  },
  planToday: { defaultMessage: "Planned today", id: "knlGoB", description: "portal today plan" },
  dayOff: { defaultMessage: "Day off", id: "UZLtyx", description: "portal: no planned work" },
  workedToday: { defaultMessage: "Worked", id: "piXv3I", description: "portal: worked minutes" },
  pendingWeeks: {
    defaultMessage: "{count, plural, one {# week waits} other {# weeks wait}} for your validation.",
    id: "j9QnUk",
    description: "portal: unsigned weeks banner",
  },
  goSign: {
    defaultMessage: "Validate",
    id: "g3/Wol",
    description: "portal: go to week validation",
  },
  // records
  week: { defaultMessage: "Week of {date}", id: "VI9gpS", description: "portal week heading" },
  previous: { defaultMessage: "Previous", id: "DC7v70", description: "portal pagination" },
  next: { defaultMessage: "Next", id: "lllRxb", description: "portal pagination" },
  registered: { defaultMessage: "Recorded", id: "lHeeRW", description: "portal totals" },
  contracted: { defaultMessage: "Contracted", id: "BDoW9l", description: "portal totals" },
  balance: { defaultMessage: "Difference", id: "4Vj51y", description: "portal totals" },
  offSchedule: { defaultMessage: "Off schedule", id: "tdD55R", description: "portal totals" },
  correction: {
    defaultMessage: "Correction",
    id: "vng0tt",
    description: "portal punch is a correction",
  },
  voided: { defaultMessage: "Voided", id: "nJt+AE", description: "portal punch voided" },
  by: { defaultMessage: "by {name}", id: "hvYhqK", description: "portal: author" },
  reason: { defaultMessage: "Reason", id: "AqZbRM", description: "form field" },
  verificationCode: {
    defaultMessage: "Verification code",
    id: "UhsFrY",
    description: "punch hash",
  },
  justify: {
    defaultMessage: "Justify",
    id: "LV1idZ",
    description: "portal: justify flagged punch",
  },
  justifyPlaceholder: {
    defaultMessage: "E.g. finishing the closing, arrived early but did not start work",
    id: "97ZB8L",
    description: "portal justification placeholder",
  },
  send: { defaultMessage: "Send", id: "hqVMLQ", description: "button" },
  cancel: { defaultMessage: "Cancel", id: "9uNz+T", description: "button" },
  save: { defaultMessage: "Save", id: "RaycYK", description: "button" },
  contest: {
    defaultMessage: "Contest",
    id: "eip4CE",
    description: "portal: contest classification",
  },
  classification: {
    defaultMessage: "{minutes} counted as {kind} — {reason}",
    id: "QRLGOH",
    description: "portal classification line",
  },
  signWeek: { defaultMessage: "Validate this week", id: "Q6urt8", description: "portal sign week" },
  agree: { defaultMessage: "I agree with the record", id: "mky3Ti", description: "portal sign" },
  disagree: { defaultMessage: "I disagree", id: "VAJyqm", description: "portal sign" },
  signNote: {
    defaultMessage: "Remarks (required when you disagree)",
    id: "Fgr/yW",
    description: "portal sign note",
  },
  signed: {
    defaultMessage: "Validated on {date} ({status}). Code: {hash}",
    id: "Miq5tW",
    description: "portal signed week",
  },
  agreed: { defaultMessage: "agreed", id: "N4iYth", description: "portal signed status" },
  disagreed: {
    defaultMessage: "with disagreement",
    id: "y0LoWJ",
    description: "portal signed status",
  },
  weekOpen: {
    defaultMessage: "The week can be validated once it has ended.",
    id: "+Vpi4t",
    description: "portal week still open",
  },
  downloadCsv: { defaultMessage: "Download CSV", id: "SCfrVW", description: "portal export" },
  print: { defaultMessage: "Print / PDF", id: "iv1wu8", description: "portal export" },
  noPunches: { defaultMessage: "No punches", id: "xaRlWy", description: "portal empty day" },
  // flags
  flag_no_location: { defaultMessage: "no location", id: "CTTAeo", description: "punch flag" },
  flag_low_accuracy: {
    defaultMessage: "imprecise location",
    id: "APH8h4",
    description: "punch flag",
  },
  flag_outside_geofence: {
    defaultMessage: "outside the site",
    id: "RDTmyc",
    description: "punch flag",
  },
  flag_ip_mismatch: { defaultMessage: "other network", id: "Dm1Mr+", description: "punch flag" },
  flag_off_schedule: { defaultMessage: "off schedule", id: "HxkSTI", description: "punch flag" },
  flag_open_session: { defaultMessage: "still open", id: "ZeFBjG", description: "day flag" },
  flag_short_rest: {
    defaultMessage: "rest under the minimum",
    id: "DZ0/Hm",
    description: "day flag",
  },
  flag_off_schedule_time: {
    defaultMessage: "time off schedule",
    id: "E1Fv+A",
    description: "day flag",
  },
  // roster
  roster: { defaultMessage: "Shift roster", id: "22rd4G", description: "portal roster title" },
  rosterHint: {
    defaultMessage: "The published roster is the official work-schedule map.",
    id: "4UWH5X",
    description: "portal roster hint",
  },
  lateChange: {
    defaultMessage: "late change",
    id: "iqV9FP",
    description: "roster line changed late",
  },
  mySwaps: { defaultMessage: "Shift swaps", id: "PYwSLQ", description: "portal swaps title" },
  askSwap: { defaultMessage: "Ask for a swap", id: "MVqcAl", description: "portal swap request" },
  myDate: { defaultMessage: "My day", id: "lloStU", description: "swap form" },
  colleague: { defaultMessage: "Colleague", id: "p2jtGe", description: "swap form" },
  colleagueDate: { defaultMessage: "Colleague's day", id: "7Ng5Qf", description: "swap form" },
  accept: { defaultMessage: "Accept", id: "skPoVe", description: "button" },
  refuse: { defaultMessage: "Refuse", id: "JD8M1U", description: "button" },
  swapStatus: {
    defaultMessage:
      "{status, select, requested {Waiting for colleague} accepted {Waiting for management} approved {Approved} other {Refused}}",
    id: "/3rW8k",
    description: "swap status",
  },
  // overtime
  overtimeTitle: { defaultMessage: "Overtime", id: "A3LKBh", description: "portal overtime title" },
  overtimeHint: {
    defaultMessage:
      "Overtime must be authorised beforehand. Staying without authorisation is recorded but counted as an unauthorised stay.",
    id: "qO7zNk",
    description: "portal overtime hint",
  },
  date: { defaultMessage: "Date", id: "+Ke7oO", description: "form field" },
  minutes: { defaultMessage: "Minutes", id: "yZJjpR", description: "form field" },
  requestOvertime: {
    defaultMessage: "Request",
    id: "UOD81I",
    description: "portal overtime request",
  },
  pending: { defaultMessage: "Pending", id: "j64WEx", description: "status" },
  approved: { defaultMessage: "Authorised", id: "/qfDzf", description: "status" },
  refused: { defaultMessage: "Not authorised", id: "Mgw4fz", description: "status" },
  oppositions: {
    defaultMessage: "Notes from management",
    id: "CR267o",
    description: "portal stay oppositions title",
  },
  // profile
  myData: { defaultMessage: "My data", id: "VEPdoE", description: "portal profile title" },
  dataHint: {
    defaultMessage: "To correct these details, ask management.",
    id: "LcDmB9",
    description: "portal profile hint",
  },
  documents: {
    defaultMessage: "Documents in force",
    id: "m2Uoo8",
    description: "portal policies title",
  },
  // management
  alerts: { defaultMessage: "Alerts", id: "S4k7lB", description: "portal management" },
  noAlerts: { defaultMessage: "No alerts.", id: "YTLGRD", description: "portal management" },
  overtimeRequests: {
    defaultMessage: "Overtime requests",
    id: "qL50ch",
    description: "portal management",
  },
  overstays: {
    defaultMessage: "Unauthorised stays (real time)",
    id: "ervy1H",
    description: "portal management",
  },
  oppose: { defaultMessage: "Record opposition", id: "LEWt5P", description: "portal management" },
  opposeDefault: {
    defaultMessage: "Not authorised; the colaborador was told to end the working day.",
    id: "rNG9f9",
    description: "portal opposition default text",
  },
  opposed: {
    defaultMessage: "Opposition recorded",
    id: "dR01B6",
    description: "portal management",
  },
  realWorkHint: {
    defaultMessage:
      "If the person was really working because there was work to do, authorise it: refusing real work only to avoid paying it loses in court.",
    id: "HdamIv",
    description: "portal management hint",
  },
  swapsToDecide: {
    defaultMessage: "Swaps to approve",
    id: "UQSzZM",
    description: "portal management",
  },
  employees: { defaultMessage: "Colaboradores", id: "ZGdgvj", description: "portal management" },
  newEmployee: { defaultMessage: "New profile", id: "zp6yiq", description: "portal management" },
  staffUserId: {
    defaultMessage: "Staff user ID",
    id: "8tIjwb",
    description: "portal management: user id field for new profile",
  },
  open: { defaultMessage: "Open", id: "kIRXNk", description: "button" },
  back: { defaultMessage: "Back", id: "0OfZJA", description: "button" },
  profile: { defaultMessage: "Profile", id: "8OWcea", description: "portal employee" },
  classify: { defaultMessage: "Classify", id: "zrhl2C", description: "portal classify time" },
  correct: { defaultMessage: "Correct", id: "jPSKMQ", description: "portal correct punch" },
  voidPunch: { defaultMessage: "Void", id: "AawyNK", description: "portal void punch" },
  addPunch: { defaultMessage: "Add missing punch", id: "erxxch", description: "portal add punch" },
  time: { defaultMessage: "Time", id: "oSEWqk", description: "form field" },
  kind: { defaultMessage: "Kind", id: "lwHGlB", description: "form field" },
  // setup
  shifts: { defaultMessage: "Shifts", id: "LVNslX", description: "portal setup" },
  newShift: { defaultMessage: "New shift", id: "RorRLc", description: "portal setup" },
  name: { defaultMessage: "Name", id: "ex7OZe", description: "form field" },
  start: { defaultMessage: "Start", id: "52u655", description: "form field" },
  end: { defaultMessage: "End", id: "ageAxS", description: "form field" },
  breakMinutes: { defaultMessage: "Break (min)", id: "lHHTfX", description: "form field" },
  publishRoster: { defaultMessage: "Publish roster", id: "ksh1hW", description: "portal setup" },
  rosterSaved: {
    defaultMessage: "{count} lines published.",
    id: "tCi7hO",
    description: "portal roster published",
  },
  workSites: { defaultMessage: "Work sites", id: "FSUaW2", description: "portal setup" },
  radius: { defaultMessage: "Radius (m)", id: "+wnqqj", description: "form field" },
  ipRanges: {
    defaultMessage: "Office public IPs (one per line)",
    id: "DxgikB",
    description: "form field",
  },
  rules: { defaultMessage: "Rules", id: "ToY2un", description: "portal setup" },
  rulesHint: {
    defaultMessage: "Defaults follow the Labour Code; your collective agreement (IRCT) may differ.",
    id: "80RDqR",
    description: "portal setup",
  },
  policies: { defaultMessage: "Documents", id: "bjJejJ", description: "portal setup" },
  publishPolicy: {
    defaultMessage: "Publish new version",
    id: "zIbzA8",
    description: "portal setup",
  },
  title: { defaultMessage: "Title", id: "o27BLy", description: "form field" },
  text: { defaultMessage: "Text", id: "LwjPRM", description: "form field" },
  chain: { defaultMessage: "Record integrity", id: "MEr0qn", description: "portal setup" },
  chainOk: {
    defaultMessage: "Hash chain intact: {count} records verified.",
    id: "BS31+Z",
    description: "portal setup",
  },
  chainBroken: {
    defaultMessage: "Chain broken at record {seq}: {error}",
    id: "Gznsm+",
    description: "portal setup",
  },
  saved: { defaultMessage: "Saved.", id: "W+b87O", description: "portal saved" },
  error: { defaultMessage: "Error: {message}", id: "cj4dpc", description: "portal error" },
  absencesModule: { defaultMessage: "Time off", id: "a7OrZ0", description: "portal" },
  signDay: { defaultMessage: "Sign the day", id: "0SgrZM", description: "portal" },
  pendingDays: {
    defaultMessage: "{count, plural, one {# day waits} other {# days wait}} for your signature.",
    id: "mmKmhH",
    description: "portal",
  },
  entryPinLabel: {
    defaultMessage: "Entry PIN (ask management)",
    id: "SCWhEY",
    description: "portal",
  },
  lunchPinLabel: { defaultMessage: "Lunch return PIN", id: "NOH6FW", description: "portal" },
  locationRequired: {
    defaultMessage:
      "Location is required to punch. Allow location access for this site and try again.",
    id: "JI/jIE",
    description: "portal",
  },
  workingDays: {
    defaultMessage: "{count, plural, one {# working day} other {# working days}}",
    id: "3Bh7DJ",
    description: "portal",
  },
  attachProof: { defaultMessage: "Attach proof", id: "z+p7Sw", description: "portal" },
  vacationYear: { defaultMessage: "Vacation {year}", id: "BBNtdV", description: "portal" },
  vacationWindow: {
    defaultMessage: "usable {from} – {until}",
    id: "IzsPrp",
    description: "portal",
  },
  vacationPending: { defaultMessage: "{count} pending", id: "NaxYQ+", description: "portal" },
  vacationBalance: { defaultMessage: "Vacation balance", id: "oGMLAZ", description: "portal" },
  vacationHint: {
    defaultMessage:
      "Working days (Mon–Fri, not holidays). First year: 2 days per full month, up to 20, after 6 months. Unused days until 30 April of the next year.",
    id: "lc0VtS",
    description: "portal",
  },
  requestAbsence: {
    defaultMessage: "Request vacation / absence",
    id: "c99JgH",
    description: "portal",
  },
  proofHint: {
    defaultMessage:
      "For sick leave or a justified absence, attach the proof after sending (PDF or photo). Only you and management can see it.",
    id: "OV0PyP",
    description: "portal",
  },
  myAbsences: { defaultMessage: "My requests", id: "KskF7+", description: "portal" },
  teamCalendar: { defaultMessage: "Team calendar", id: "ZPeHu3", description: "portal" },
  todaysPins: { defaultMessage: "Today's PINs", id: "aHw27g", description: "portal" },
  rotatePin: { defaultMessage: "New PIN", id: "dzyZa+", description: "portal" },
  pinHint: {
    defaultMessage:
      "The PIN changes every minute. Show it only on site (e.g. a screen at the entrance); it is useless outside the site network.",
    id: "mvvQKQ",
    description: "portal",
  },
  absenceRequests: {
    defaultMessage: "Vacation and absence requests",
    id: "hdwefc",
    description: "portal",
  },
  registerAbsence: { defaultMessage: "Register an absence", id: "jo8YCp", description: "portal" },
  monthApprovals: { defaultMessage: "Approved months", id: "Purlsm", description: "portal" },
  approveMonth: {
    defaultMessage: "Approve {month} and send the summary",
    id: "eBOzi2",
    description: "portal",
  },
  approveMonthHint: {
    defaultMessage:
      "The approved summary is emailed to the colaborador as their copy of the record.",
    id: "q4mj3q",
    description: "portal",
  },
  claimTime: { defaultMessage: "Actual arrival time", id: "rDxJIn", description: "portal" },
  claimHint: {
    defaultMessage: "The punch keeps the current time until management approves.",
    id: "oUlEUy",
    description: "portal",
  },
  claimOpen: { defaultMessage: "I arrived earlier", id: "4Jn6B1", description: "portal" },
  claimLine: {
    defaultMessage:
      "Stated time {time}: {status, select, pending {pending} approved {approved} other {refused}}",
    id: "2KN9IF",
    description: "portal",
  },
  claimsTitle: { defaultMessage: "Stated arrival times", id: "IZ6+ZX", description: "portal" },
  claimDecideLine: {
    defaultMessage: "punched {recorded}, states {claimed}",
    id: "VOinO9",
    description: "portal",
  },
  missing: { defaultMessage: "Missing", id: "Lpx2sr", description: "portal" },
  tolerated: { defaultMessage: "Tolerated", id: "mpanH0", description: "portal" },
  missingDays: { defaultMessage: "= {days} days", id: "Gt3bAw", description: "portal" },
  unclassified: { defaultMessage: "To classify", id: "KWhl0e", description: "portal" },
  justified: { defaultMessage: "Justified", id: "50U0GS", description: "portal" },
  unjustified: { defaultMessage: "Unjustified", id: "Udd4l2", description: "portal" },
  compensated: { defaultMessage: "Compensated", id: "Awe319", description: "portal" },
  overCap: {
    defaultMessage: "{minutes} min over the monthly cap",
    id: "QQkDtO",
    description: "portal",
  },
  approvedOvertime: { defaultMessage: "Approved overtime", id: "4cF+pP", description: "portal" },
  compensationWork: { defaultMessage: "Compensation work", id: "cI51kf", description: "portal" },
  unauthorizedStay: { defaultMessage: "Unauthorised stay", id: "qVfJ+4", description: "portal" },
  balanceTitle: { defaultMessage: "Balance", id: "u55TMT", description: "portal" },
  noOffsetHint: {
    defaultMessage:
      "Missing time and extra time never offset each other, except by an approved compensation.",
    id: "hT5QdR",
    description: "portal",
  },
  compensationTitle: {
    defaultMessage: "Compensation by agreement",
    id: "yrYmaC",
    description: "portal",
  },
  compensationHint: {
    defaultMessage:
      "Make up missing time on another day, e.g. Saturday (never Sunday or a holiday), with management's approval. It is not overtime.",
    id: "jsh1jK",
    description: "portal",
  },
  missingDay: { defaultMessage: "Day with missing time", id: "7zcYcw", description: "portal" },
  compensationDay: { defaultMessage: "Compensation day", id: "tX5yLV", description: "portal" },
  balanceReport: { defaultMessage: "Balances this month", id: "WC5rgA", description: "portal" },
  punctualityDays: {
    defaultMessage: "{count, plural, one {# day} other {# days}} late/early",
    id: "X6w3xt",
    description: "portal",
  },
  flag_during_absence: { defaultMessage: "during an absence", id: "wTFWnj", description: "portal" },
  flag_no_record: { defaultMessage: "no record", id: "qrx4m0", description: "portal" },
  flag_missing_time: { defaultMessage: "missing time", id: "2q3MBZ", description: "portal" },
  entryPinTitle: { defaultMessage: "Entry PIN", id: "5101Bc", description: "portal" },
  lunchPinTitle: { defaultMessage: "Lunch return PIN", id: "NOH6FW", description: "portal" },
  offNetwork: {
    defaultMessage: "You are not on the work site's Wi-Fi: connect to it to punch.",
    id: "Oed8rf",
    description: "portal",
  },
  kioskMode: {
    defaultMessage: "Kiosk: you will be signed out after punching.",
    id: "TjOnk+",
    description: "portal",
  },
  reportBeforeLeaving: {
    defaultMessage: "Submit today's report before clocking out.",
    id: "h7xUS8",
    description: "portal",
  },
  writeReport: { defaultMessage: "Write report", id: "+NLzGY", description: "portal" },
  networkNotice: {
    defaultMessage:
      "Punches are accepted on the work site's network with the PIN shown on site. No location is collected; the time is the server's.",
    id: "vllhSI",
    description: "portal",
  },
  notifications: { defaultMessage: "Notifications", id: "X6nv6/", description: "portal" },
  markAllRead: { defaultMessage: "Mark all as read", id: "J4j7nf", description: "portal" },
  dueAt: { defaultMessage: "due {when}", id: "lBaW/j", description: "portal" },
  markDone: { defaultMessage: "Mark as done", id: "dkfkNt", description: "portal" },
  returnedNote: { defaultMessage: "Returned: {note}", id: "cLVW7W", description: "portal" },
  doneNotePlaceholder: {
    defaultMessage: "What was done (optional)",
    id: "HeJhBE",
    description: "portal",
  },
  reportFor: { defaultMessage: "What I did on {day}", id: "2WWlpU", description: "portal" },
  myTasks: { defaultMessage: "My tasks", id: "gr4czr", description: "portal" },
  noTasks: { defaultMessage: "No open tasks.", id: "E5Fp7i", description: "portal" },
  dailyReport: { defaultMessage: "Daily report", id: "YudfvN", description: "portal" },
  reportRequiredHint: {
    defaultMessage:
      "Your role requires a daily report. Write it during working time, before clocking out.",
    id: "byuvaM",
    description: "portal",
  },
  reportOptionalHint: {
    defaultMessage: "Optional: describe what you did today.",
    id: "TXWHPO",
    description: "portal",
  },
  history: { defaultMessage: "History", id: "Wl9qt2", description: "portal" },
  whatIsMissing: { defaultMessage: "What is missing", id: "am8853", description: "portal" },
  returnIt: { defaultMessage: "Return", id: "czeB/q", description: "portal" },
  toApprove: { defaultMessage: "Done, waiting for approval", id: "CKPkvj", description: "portal" },
  reportsToReview: {
    defaultMessage: "Daily reports to review",
    id: "Bfd36u",
    description: "portal",
  },
  newTask: { defaultMessage: "New task", id: "EOZP8r", description: "portal" },
  assignee: { defaultMessage: "Assignee", id: "WTcShu", description: "portal" },
  eta: { defaultMessage: "Deadline (ETA)", id: "m4Kwai", description: "portal" },
  assign: { defaultMessage: "Assign", id: "noTI87", description: "portal" },
  etaHint: {
    defaultMessage:
      "The deadline must fall within the person's working hours (rest periods and the duty not to contact, art. 199.º-A).",
    id: "KThp3l",
    description: "portal",
  },
  openTasks: { defaultMessage: "Open tasks", id: "Axd+PZ", description: "portal" },
  recurringTasks: { defaultMessage: "Recurring tasks", id: "grajxs", description: "portal" },
  pinChangesIn: { defaultMessage: "changes in {seconds} s", id: "OOhpGd", description: "portal" },
  pinFullScreen: { defaultMessage: "Full screen", id: "HjjAa3", description: "portal" },
  newDevices: { defaultMessage: "New devices to approve", id: "sKXDzS", description: "portal" },
  newDevicesHint: {
    defaultMessage: "Approve only a device the person confirms is theirs (e.g. a new phone).",
    id: "6C0gTR",
    description: "portal",
  },
  rolesTitle: {
    defaultMessage: "Roles: tasks and daily reports",
    id: "w6m/ii",
    description: "portal",
  },
  roleTasks: { defaultMessage: "Tasks", id: "QpY40i", description: "portal" },
  roleReport: { defaultMessage: "Daily report required", id: "X6PoFl", description: "portal" },
  rolesHint: {
    defaultMessage:
      "Same rules for everyone in a role. Put people in a role on the staff page of the dashboard.",
    id: "c9HBm+",
    description: "portal",
  },
  kiosks: {
    defaultMessage: "Kiosks (shared devices on site)",
    id: "bqv8lN",
    description: "portal",
  },
  registerKiosk: {
    defaultMessage: "Register this device as a kiosk",
    id: "nEWveW",
    description: "portal",
  },
  forgetKiosk: { defaultMessage: "Stop being a kiosk", id: "fvZXpq", description: "portal" },
  isKiosk: { defaultMessage: "This device is a kiosk.", id: "ireG5T", description: "portal" },
  kioskHint: {
    defaultMessage:
      "Optional. With 'kiosk only' on, punches are only accepted on registered kiosks.",
    id: "5G9IL2",
    description: "portal",
  },
  exportHint: {
    defaultMessage: "Records, sign-offs, seals and a verifier anyone can run (last 12 months).",
    id: "0VDb6c",
    description: "portal",
  },
  exportRecord: { defaultMessage: "Export (verifiable)", id: "48QAVJ", description: "portal" },
  tasksModule: { defaultMessage: "Tasks", id: "QpY40i", description: "portal" },
  manageTasksModule: { defaultMessage: "Tasks", id: "QpY40i", description: "portal" },
  flag_remote: { defaultMessage: "off site network", id: "3wDu9K", description: "portal" },
  flag_shared_device: {
    defaultMessage: "someone else's device",
    id: "3lgcIY",
    description: "portal",
  },
  usersModule: { defaultMessage: "Users", id: "IcGC2g", description: "portal" },
  users: { defaultMessage: "Portal accounts", id: "XPtHAA", description: "portal" },
  newUser: { defaultMessage: "New account", id: "6Z/L/s", description: "portal" },
  usernameLabel: { defaultMessage: "Username", id: "cfLDv0", description: "portal" },
  initialPassword: { defaultMessage: "Initial password", id: "bvWioU", description: "portal" },
  role: { defaultMessage: "Role", id: "attJFW", description: "portal" },
  hireDateLabel: { defaultMessage: "Hire date", id: "R3S6s7", description: "portal" },
  personalEmailLabel: {
    defaultMessage: "Personal email (password reset only)",
    id: "okgUG9",
    description: "portal",
  },
  createUser: { defaultMessage: "Create account", id: "rF3vWc", description: "portal" },
  newUserHint: {
    defaultMessage:
      "Portal accounts only: they cannot open the dashboard. Give the username and initial password to the person in private.",
    id: "Pcyn3M",
    description: "portal",
  },
  lastLogin: { defaultMessage: "last sign-in {when}", id: "8/nF6/", description: "portal" },
  deactivate: { defaultMessage: "Deactivate", id: "s0vrIa", description: "portal" },
  reactivate: { defaultMessage: "Reactivate", id: "KNOIhu", description: "portal" },
  newPassword: { defaultMessage: "New password", id: "g/qwkJ", description: "portal" },
  newPasswordHint: {
    defaultMessage: "New password (signs the person out everywhere)",
    id: "dHxNX0",
    description: "portal",
  },
  managedInDashboard: {
    defaultMessage: "managed in the dashboard",
    id: "STkPHz",
    description: "portal",
  },
  inactive: { defaultMessage: "Inactive", id: "EJsPH6", description: "portal" },
  sectionMine: { defaultMessage: "My work", id: "m0rtzh", description: "portal sidebar section" },
  sectionManage: {
    defaultMessage: "Management",
    id: "A/Mm24",
    description: "portal sidebar section",
  },
  shiftsPlannerModule: {
    defaultMessage: "Generate shifts",
    id: "6b4qiO",
    description: "portal nav: shift planner",
  },
  menu: { defaultMessage: "Menu", id: "AywgQc", description: "portal: open sidebar on mobile" },
  previousLogin: {
    defaultMessage: "Last sign-in: {when} ({platform})",
    id: "iMOe6K",
    description: "portal top bar: previous successful sign-in",
  },
  firstLogin: {
    defaultMessage: "First sign-in",
    id: "5V6nFn",
    description: "portal top bar: no previous sign-in",
  },
  failedSince: {
    defaultMessage: "{count, plural, one {# failed attempt since} other {# failed attempts since}}",
    id: "3h9Gry",
    description: "portal top bar: failed sign-ins since the previous one",
  },
  edit: { defaultMessage: "Edit", id: "Ja7gHc", description: "button" },
  completeProfileTitle: {
    defaultMessage: "Complete your details",
    id: "aZcTkQ",
    description: "portal first sign-in: personal data step",
  },
  completeProfileBody: {
    defaultMessage:
      "Before using the portal, fill in your contacts. They are only used for your employment relationship (see the privacy notice) and only management can see them.",
    id: "IRoaJW",
    description: "portal first sign-in: personal data step",
  },
  requiredField: { defaultMessage: "Required", id: "M/DiXM", description: "portal form" },
  function: { defaultMessage: "Role", id: "YesoNO", description: "portal profile: portal role" },
  continue: { defaultMessage: "Continue", id: "Rjs1CD", description: "button" },
  companyData: {
    defaultMessage: "Employment (set by management)",
    id: "2CRUtO",
    description: "portal profile section",
  },
  newWorkSite: { defaultMessage: "New site", id: "GSmBqG", description: "button" },
  newDocument: { defaultMessage: "New version", id: "dnDYwV", description: "button" },
  loadTemplate: { defaultMessage: "Load template", id: "69qMT7", description: "button" },
  templateHint: {
    defaultMessage:
      "The template is a draft: fill in the fields in [brackets], review it with your lawyer and only then publish. Everyone will be asked to acknowledge it.",
    id: "D82E42",
    description: "portal setup: policy template",
  },
  yes: { defaultMessage: "Yes", id: "lqZHWA", description: "portal" },
  no: { defaultMessage: "No", id: "d0R+xe", description: "portal" },
  rosterMoved: {
    defaultMessage:
      "Here you only define the shift templates (e.g. Saturday 09:00–15:00). The roster is generated in “Generate shifts”.",
    id: "WsUTPY",
    description: "portal setup",
  },
  rotaIntro: {
    defaultMessage:
      "Only colaboradores with a shift schedule take part. Choose any period (a week, a month, a year), how many people each Saturday needs and how the Saturday is compensated. The proposal respects vacations and absences, rotates fairly and is only published when you press Publish.",
    id: "d3E1FW",
    description: "portal rota",
  },
  noShiftWorkers: {
    defaultMessage: "Nobody works shifts yet: choose who does in “Who works shifts” above (Edit).",
    id: "HYhoDa",
    description: "portal rota",
  },
  noSaturdayShift: {
    defaultMessage:
      "Create the Saturday shift first (Settings → Shifts), e.g. 09:00–15:00 with a 60 min break.",
    id: "U/J4Jn",
    description: "portal rota",
  },
  presetNextWeek: {
    defaultMessage: "Next week",
    id: "XOEj7f",
    description: "portal rota",
  },
  presetNextMonth: {
    defaultMessage: "Next month",
    id: "P1GJzT",
    description: "portal rota",
  },
  presetRestOfYear: {
    defaultMessage: "Rest of the year",
    id: "80hK2o",
    description: "portal rota",
  },
  presetNextYear: {
    defaultMessage: "Next year",
    id: "0CkenH",
    description: "portal rota",
  },
  saturdayShift: {
    defaultMessage: "Saturday shift",
    id: "SDCO+5",
    description: "portal rota",
  },
  minPerSaturday: {
    defaultMessage: "People per Saturday",
    id: "FkdMNj",
    description: "portal rota",
  },
  compensationMode: {
    defaultMessage: "Compensation",
    id: "TmqMwL",
    description: "portal rota",
  },
  modeSameWeek: {
    defaultMessage: "Day off in the same week (no week above 40 h)",
    id: "L4DKCQ",
    description: "portal rota",
  },
  adaptabilityHint: {
    defaultMessage:
      "Adaptability (arts. 204.º–207.º CT) needs the colaborador's written agreement or a collective agreement that provides for it.",
    id: "pzfhyg",
    description: "portal rota",
  },
  generate: {
    defaultMessage: "Generate proposal",
    id: "Beci9w",
    description: "portal rota",
  },
  generateHint: {
    defaultMessage: "Replaces the unpublished changes below.",
    id: "ztdMdd",
    description: "portal rota",
  },
  dragHint: {
    defaultMessage:
      "Drag a Saturday or a day off along the row to change the day, or up/down to give it to a colleague. Click a cell to choose.",
    id: "Z95uJs",
    description: "portal rota",
  },
  hoursPerWeek: {
    defaultMessage: "h/week",
    id: "oNOY0/",
    description: "portal rota",
  },
  legendBase: {
    defaultMessage: "Normal schedule",
    id: "FkDtt8",
    description: "portal rota",
  },
  legendDraft: {
    defaultMessage: "Not yet published",
    id: "Z2Ducj",
    description: "portal rota",
  },
  legendAbsent: {
    defaultMessage: "Vacation / absence",
    id: "vjpebr",
    description: "portal rota",
  },
  discard: {
    defaultMessage: "Discard",
    id: "bm4noN",
    description: "portal rota",
  },
  draftChanges: {
    defaultMessage: "{count, plural, one {# unpublished change} other {# unpublished changes}}",
    id: "6vkHyg",
    description: "portal rota",
  },
  previewDays: {
    defaultMessage: "{count, plural, one {# working day} other {# working days}} requested",
    id: "BzbuXr",
    description: "portal absence form",
  },
  previewTotal: {
    defaultMessage: "Total {year}",
    id: "xM8729",
    description: "portal vacation preview",
  },
  previewUsed: { defaultMessage: "Taken", id: "ETUG3K", description: "portal vacation preview" },
  previewBooked: {
    defaultMessage: "Booked / pending",
    id: "iTkvip",
    description: "portal vacation preview",
  },
  previewThis: {
    defaultMessage: "This request",
    id: "m3+rNN",
    description: "portal vacation preview",
  },
  previewRemaining: {
    defaultMessage: "Left afterwards",
    id: "/+DRh6",
    description: "portal vacation preview",
  },
  registerVacationHint: {
    defaultMessage:
      "You can register this year's vacations already taken (past dates) or already agreed; they are saved as approved and the colaborador is notified.",
    id: "borIFw",
    description: "portal employee page",
  },
  newUserButton: { defaultMessage: "New user", id: "LchMS6", description: "button" },
  status: { defaultMessage: "Status", id: "c/5m2p", description: "portal users table" },
  active: { defaultMessage: "Active", id: "gaYhZj", description: "portal users table" },
  lastLoginColumn: {
    defaultMessage: "Last sign-in",
    id: "HR+ICF",
    description: "portal users table",
  },
  never: { defaultMessage: "never", id: "JOwCcI", description: "portal users: never signed in" },
  passwordOptional: {
    defaultMessage: "New password (leave empty to keep)",
    id: "M/2wDj",
    description: "portal users edit",
  },
  kindBreastfeeding: {
    defaultMessage: "Breastfeeding dispensation",
    id: "2TC7bJ",
    description: "portal absence kind",
  },
  kindPrenatal: {
    defaultMessage: "Prenatal appointment dispensation",
    id: "FC+7pC",
    description: "portal absence kind",
  },
  dispensation: { defaultMessage: "Dispensation", id: "bP5Qaq", description: "portal day summary" },
  dispensationPeriods: {
    defaultMessage: "Periods of each working day",
    id: "hC8uGU",
    description: "portal dispensation form",
  },
  addPeriod: { defaultMessage: "Add period", id: "R45QXJ", description: "button" },
  dispensationHint: {
    defaultMessage:
      "Counts as time worked: no pay is lost and nothing has to be made up. Breastfeeding: in principle two periods of up to 1 hour a day (e.g. the last 2 hours of the day), inside working hours; the lunch break stays at least 1 hour. Tell management 10 days in advance; after the child's first birthday a medical certificate is needed (attach it here). Only you and management see it.",
    id: "CtHBX4",
    description: "portal dispensation form",
  },
  ruleLunchMin: {
    defaultMessage: "Lunch break: minimum (min)",
    id: "26O/mv",
    description: "portal rules",
  },
  ruleLunchMax: {
    defaultMessage: "Lunch break: maximum (min)",
    id: "UKxh8w",
    description: "portal rules",
  },
  scheduleHistory: {
    defaultMessage: "Schedule history",
    id: "4hmQzQ",
    description: "portal employee page",
  },
  scheduleHistoryHint: {
    defaultMessage:
      "Changing someone's hours or lunch break is a change of schedule: give the legal notice, and get the person's agreement if the schedule was agreed individually. Differences between people need an objective reason (role, section, shift, cover).",
    id: "UkuCUF",
    description: "portal employee page",
  },
  modeAverage: {
    defaultMessage:
      "40 h on average: the Saturday week is longer (e.g. 46 h) and the Saturday hours become whole days off in the following weeks",
    id: "1ac+Zc",
    description: "portal rota",
  },
  averageLine: {
    defaultMessage:
      "{name}: average {hours, number} h/week over {weeks} whole weeks{pending, select, 0 {} other { · {pending, number} h still to give back}}",
    id: "MyNBY/",
    description: "portal rota",
  },
  drawRubrica: {
    defaultMessage: "Draw your rubrica in the box",
    id: "Jmg5Sk",
    description: "portal signature pad",
  },
  clearRubrica: { defaultMessage: "Clear", id: "jRh+CG", description: "portal signature pad" },
  signPreviousFirst: {
    defaultMessage:
      "Before clocking in, put your rubrica on the previous days. If something is wrong, choose “I disagree” and explain.",
    id: "5l/qlF",
    description: "portal today",
  },
  mealAllowanceDays: {
    defaultMessage: "Full working days (meal allowance)",
    id: "mdbFQD",
    description: "portal balance",
  },
  carriedOver: {
    defaultMessage: "Carried over from {year}: take by {until}",
    id: "lLDGjN",
    description: "portal vacation balance",
  },
  goLiveDate: {
    defaultMessage: "Time book starts on",
    id: "VKvY7d",
    description: "portal rules",
  },
  longSickLeaveDays: {
    defaultMessage: "Sick leave longer than (days) = prolonged impediment",
    id: "WkfoXd",
    description: "portal rules",
  },
  absenceRulesTitle: {
    defaultMessage: "Rules per kind of absence",
    id: "g/xXj2",
    description: "portal settings",
  },
  effectiveWork: {
    defaultMessage: "Counts as work (vacations, seniority)",
    id: "8PQs3g",
    description: "portal absence rules",
  },
  companyPaid: {
    defaultMessage: "Paid by the company",
    id: "Nsgh11",
    description: "portal absence rules",
  },
  mealAllowance: {
    defaultMessage: "Meal allowance",
    id: "KBrU+b",
    description: "portal absence rules",
  },
  absenceRulesHint: {
    defaultMessage:
      "Parental leave and sick leave are paid by Segurança Social. Sick or parental leave during booked vacation suspends it: the days go back to the balance. A sick leave longer than the limit suspends the contract; gerência is alerted. Medical and family documents are only visible to gerência.",
    id: "3O9+5C",
    description: "portal absence rules",
  },
  adjustedUntil: {
    defaultMessage: "until {time}",
    id: "8btwkr",
    description: "portal rota: leaves earlier",
  },
  legendShort: {
    defaultMessage: "Leaves earlier (Saturday hours given back)",
    id: "ntjxZF",
    description: "portal rota",
  },
  legalReason: {
    defaultMessage: "Legal reason",
    id: "kR8kA6",
    description: "portal overtime",
  },
  reasonTransitory: {
    defaultMessage: "Temporary increase in work",
    id: "9eF7BG",
    description: "portal overtime reason",
  },
  reasonForceMajeure: {
    defaultMessage: "Force majeure (no limits)",
    id: "5CTMXH",
    description: "portal overtime reason",
  },
  reasonSeriousDamage: {
    defaultMessage: "Avoid serious damage to the company",
    id: "0Q/pyY",
    description: "portal overtime reason",
  },
  reasonInventory: {
    defaultMessage: "Stocktaking or sales (up to 30 days/year, ends by 22:30)",
    id: "QPGGKs",
    description: "portal overtime reason",
  },
  reasonAgreement: {
    defaultMessage: "Express agreement of both parties",
    id: "dKeiKb",
    description: "portal overtime reason",
  },
  overtimeExempt: {
    defaultMessage: "Not obliged to do overtime: {reason}. Ask only if the person agrees.",
    id: "x38HVB",
    description: "portal overtime",
  },
  overtimeToday: {
    defaultMessage: "Overtime today",
    id: "WQqTQL",
    description: "portal overtime counters",
  },
  overtimeYear: {
    defaultMessage: "Overtime this year",
    id: "VGxKHG",
    description: "portal overtime counters",
  },
  weeklyAverage: {
    defaultMessage: "Average week (incl. overtime)",
    id: "XD0UTg",
    description: "portal overtime counters",
  },
  overtimePay: {
    defaultMessage: "Paid with +{premium}%",
    id: "faflXP",
    description: "portal overtime counters",
  },
  compensatoryRest: {
    defaultMessage: "compensatory rest earned: {time}",
    id: "AJ2beC",
    description: "portal overtime counters",
  },
  orderedByManagement: {
    defaultMessage: "Ordered by management",
    id: "WJYeJM",
    description: "portal overtime",
  },
  takeNote: {
    defaultMessage: "I take note",
    id: "d4yQJ7",
    description: "button",
  },
  decline: {
    defaultMessage: "Decline",
    id: "dK8dRl",
    description: "button",
  },
  declineReason: {
    defaultMessage: "Reason for declining (e.g. exemption)",
    id: "kto5Hw",
    description: "portal overtime",
  },
  acknowledged: {
    defaultMessage: "You took note",
    id: "iWe90R",
    description: "portal overtime",
  },
  declined: {
    defaultMessage: "Declined",
    id: "KXN0E8",
    description: "portal overtime",
  },
  orderOvertime: {
    defaultMessage: "Order overtime",
    id: "Dsps88",
    description: "portal employee page",
  },
  overtimeSection: {
    defaultMessage: "Overtime",
    id: "ztFvdQ",
    description: "portal employee page",
  },
  overtimeExemption: {
    defaultMessage: "Not obliged to do overtime",
    id: "RlH8ss",
    description: "portal profile field",
  },
  exemptionUntil: {
    defaultMessage: "Until",
    id: "y83gws",
    description: "portal profile field",
  },
  modeOvertime: {
    defaultMessage: "Saturday as overtime (paid, no day off; within the legal limits)",
    id: "dyoXvn",
    description: "portal rota",
  },
  overtimeOrdersCreated: {
    defaultMessage:
      "{count, plural, one {# overtime order sent} other {# overtime orders sent}} for acknowledgement",
    id: "w/1YBP",
    description: "portal rota",
  },
  ruleWeeklyAverage: {
    defaultMessage: "Average week limit incl. overtime (h)",
    id: "8QyYeO",
    description: "portal rules",
  },
  ruleReferenceWeeks: {
    defaultMessage: "Reference period (weeks)",
    id: "rLlQOX",
    description: "portal rules",
  },
  ruleOvertimeAlert: {
    defaultMessage: "Overtime alert at (% of annual limit)",
    id: "E6WjU1",
    description: "portal rules",
  },
  ruleOvertimePremium: {
    defaultMessage: "Overtime premium (%)",
    id: "2XVMSy",
    description: "portal rules",
  },
  ruleCompensatoryRest: {
    defaultMessage: "Compensatory rest (%; 25 if more than 6 workers)",
    id: "Cljh9G",
    description: "portal rules",
  },
  exemptPregnant: {
    defaultMessage: "Pregnant",
    id: "n9x4o5",
    description: "portal overtime exemption",
  },
  exemptChild: {
    defaultMessage: "Child under 12 months",
    id: "UH7xBr",
    description: "portal overtime exemption",
  },
  exemptBreastfeeding: {
    defaultMessage: "Breastfeeding (with medical certificate)",
    id: "gTHJ9z",
    description: "portal overtime exemption",
  },
  exemptDisability: {
    defaultMessage: "Disability or chronic illness",
    id: "ipl/DL",
    description: "portal overtime exemption",
  },
  exemptStudent: {
    defaultMessage: "Working student",
    id: "j5fxH9",
    description: "portal overtime exemption",
  },
  exemptMinor: { defaultMessage: "Minor", id: "KsB2pj", description: "portal overtime exemption" },
  daysLeft: {
    defaultMessage: "{left} of {total} days left",
    id: "EnaGBQ",
    description: "portal vacation balance",
  },
  vacationCounts: {
    defaultMessage: "Taken {taken} · booked {booked} · pending {pending}",
    id: "Agmclg",
    description: "portal vacation balance",
  },
  bonusEarned: {
    defaultMessage: "Includes +{days} bonus days",
    id: "YCQTzr",
    description: "portal vacation balance",
  },
  bonusIfApproved: {
    defaultMessage: "+{days} bonus days once approved",
    id: "wHq+hh",
    description: "portal vacation balance",
  },
  carriedVacationDays: {
    defaultMessage: "Vacation days carried over (start of the time book)",
    id: "GVFiJV",
    description: "portal profile field",
  },
  ruleVacationBonus: {
    defaultMessage:
      "Vacation bonus (CCT): +3 days for 22 days in one block Jan–Apr, +2 for two blocks of 11 (Jan–Apr and May–Oct)",
    id: "uJ5DCi",
    description: "portal rules",
  },
  rosterEmpty: {
    defaultMessage: "No shifts published for these weeks: your normal schedule applies.",
    id: "Jb64CV",
    description: "portal roster empty",
  },
  rosterEmptyManager: {
    defaultMessage:
      "No shifts published for these weeks. Use “Generate shifts” to plan the Saturdays (people with schedule type “Shifts” and a Saturday shift template are needed).",
    id: "WSy5Dq",
    description: "portal roster empty",
  },
  shiftPeopleTitle: {
    defaultMessage: "Who works shifts",
    id: "NcvTPp",
    description: "portal rota",
  },
  shiftPeopleHint: {
    defaultMessage:
      "Ticked people take part in the Saturday rota; on weekdays they keep their weekly schedule.",
    id: "roNx3o",
    description: "portal rota",
  },
  nobodyInShifts: { defaultMessage: "Nobody yet.", id: "vNBegr", description: "portal rota" },
  noProfilesYet: {
    defaultMessage: "No colaboradores yet: create them in Users.",
    id: "e88vMo",
    description: "portal rota",
  },
  templateLunch90: {
    defaultMessage: "Mon–Fri 09:00–13:00 / 14:30–18:30 (lunch 1h30)",
    id: "ruHa2q",
    description: "portal schedule template",
  },
  templateLunch60: {
    defaultMessage: "Mon–Fri 09:00–13:00 / 14:00–18:00 (lunch 1h)",
    id: "W98tBB",
    description: "portal schedule template",
  },
  hoursPerWeekTotal: {
    defaultMessage: "{hours, number} h per week",
    id: "/tYeN3",
    description: "portal schedule",
  },
  normalHoursTitle: {
    defaultMessage: "Normal working hours",
    id: "A6XzIF",
    description: "portal settings",
  },
  normalHoursHint: {
    defaultMessage:
      "Applies to everyone without their own schedule (set in each person's page). Shifts only change the days published in the roster.",
    id: "K9sXyX",
    description: "portal settings",
  },
  companyHours: {
    defaultMessage: "company normal hours",
    id: "qen8tK",
    description: "portal employee schedule",
  },
  useCompanyHours: {
    defaultMessage: "Use company normal hours",
    id: "xWoJxa",
    description: "button",
  },
});
